import { pushAdClickToDataLayer } from '../ad_behaviours/click_tracking'

export const handleSlotRenderEnded = (event) => {
  const adElement = document.getElementById(event.slot.getSlotElementId());
  const iframe = adElement.querySelector('iframe');

  if (event.isEmpty) {
    adElement.dataset.googleAdLoadSuccess = 'false'
    return;
  }

  adElement.dataset.googleAdLoadSuccess = 'true'
  adElement.dataset.googleAdLineItemId = event.lineItemId

  const clickDataElement = document.createElement('div');
  clickDataElement.classList.add('click_data_element');
  clickDataElement.style.display = 'none';

  // If the ad is from a 3rd party source, we cannot access iframe.contentDocument
  const iframeClickElement = iframe.contentDocument && iframe.contentDocument.body.querySelector('a');
  const googleClickThroughUrl = iframeClickElement ? iframeClickElement.href : null;
  const clickThroughUrl = googleClickThroughUrl ? new URL(googleClickThroughUrl).searchParams.get('adurl') : null;

  // do not mess with this! we base most of our reporting from attributes in this event. Check with the wider team first.
  const clickDataElementProperties = {
    interactionType: 'google ad',
    adLineItemId: event.lineItemId,
    adUnitPath: event.slot.getAdUnitPath(),
    advertiserId: event.advertiserId,
    campaignId: event.campaignId,
    creativeId: event.creativeId,
    size: event.size,
    googleClickThroughUrl: googleClickThroughUrl,
    clickThroughUrl: clickThroughUrl,
    ...event.slot.getTargetingMap(),
  };

  Object.assign(clickDataElement.dataset, clickDataElementProperties);
  adElement.appendChild(clickDataElement);

  // We actually fire a 'google impression' event to our internal data layer here even though it's technically too early
  // this is because google don't expose their impression event to us.
  // The upshot here is that carwow's "Google Impression" numbers are not *quite* the same as Google's.

  // set values to null to prevent GTM recursively merging the eventParams object
  window.dataLayer.push({ event: 'resetting_objects', eventName: null, eventParams: null })
  
  window.dataLayer.push({
    event: 'trackable event',
    eventName: 'Google impression',
    eventParams: clickDataElement.dataset,
  });

  if (adElement.dataset.fullHeight) {
    iframe.style.height = '100%';
    iframe.parentNode.style.height = '100%';
  }

  window.googleAdIframes = window.googleAdIframes || [];
  window.googleAdIframes.push(iframe);

  if (clickThroughUrl) {
    iframe.contentDocument.body.addEventListener('click', () => {
      pushAdClickToDataLayer(clickDataElement, clickThroughUrl);
    });
  }
}
